import { IResponse } from '@estee/elc-http-transport';
import { IPGResponse, IToken } from '~api/CartAPI/ICartApiSdk';

export const getCsrfTokenFromCookie = () => {
    const regex = new RegExp('(^| )csrftoken=([^;]+)');
    const match = document.cookie.match(regex);

    return match ? decodeURIComponent(match[2]) : '';
};

export const dgbMethod = (method: string): string => {
    return `dgbmethod=${method}`;
};

export const formatToRPC = (method: string, payload: unknown) => {
    const boilerplate = [
        {
            method,
            params: payload
        }
    ];
    const data = new URLSearchParams();
    data.append('JSONRPC', JSON.stringify(boilerplate));

    return data;
};

export const mapCsrfToken = (response: IResponse<IPGResponse<IToken>[]>) => {
    let csrfToken: string = '';
    response.data?.map(({ result }) => {
        const { token } = result.value as IToken;
        csrfToken = token || '';
    });

    return csrfToken;
};

export class Throttle<T> {
    private callback;
    private throttleTimer = 0;
    private throttleMS = 10;
    private currentRequest: Promise<T> | null = null;

    constructor(callback: () => Promise<T>) {
        this.callback = callback;
    }

    public execute = (): Promise<T> => {
        if (!this.currentRequest) {
            this.currentRequest = new Promise((resolve, reject) => {
                clearTimeout(this.throttleTimer);

                this.throttleTimer = setTimeout(() => {
                    try {
                        resolve(this.callback());
                    } catch (e) {
                        reject(e);
                    }

                    this.currentRequest = null;
                }, this.throttleMS);
            });
        }

        return this.currentRequest;
    };
}
